import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { N1PortfoliosEdit } from "./edit";
import { N1PortfoliosNew } from "./new";
import { N1PortfoliosTable } from "./table";
export default function N1Portfolios() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Portefeuilles");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<N1PortfoliosEdit />} />
      <Route index element={<N1PortfoliosTable />} />
      <Route path="/new" element={<N1PortfoliosNew />} />
    </Routes>
  );
}
